// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__95dxk","copyright":"Footer_copyright__hJ2lA"};